/* ==========================================================================
   DIREVULF — brand-wordmark.js
   The brand name as the logo, everywhere it appears as words.

   Wherever the page shows "DIRE VULF" or "DIREVULF" as text (footer, FAQ,
   policies, page headings, product notes…), the wordmark from the header is
   drawn in its place: one picture, taken from the header's own "Brand name as
   an image" setting, shown as a mask in the colour of the surrounding words
   and at their capital height (styles in layout/theme.liquid, .dv-wm).

   The words themselves stay in the page, visually hidden inside the logo, so
   screen readers say the name, copy and find-in-page still work, and the
   HTML that search engines read is unchanged.

   Left as words on purpose:
   - e-mail addresses and web addresses (support@direvulf.com, direvulf.com)
   - form fields, alt text, labels and anything else that cannot hold a picture
   - Shopify's legal policy pages
   - the Create Your Own studio, where typed text is the customer's artwork
   - the header, menu and footer logos, which are already the logo

   With no wordmark set in the header, nothing changes.
   ========================================================================== */
(function () {
  'use strict';

  var mark = document.querySelector('.dv-brand__wordmark');
  var src = mark && mark.getAttribute('src');
  if (!src || !window.CSS || !CSS.supports ||
      !(CSS.supports('mask-image', 'none') || CSS.supports('-webkit-mask-image', 'none'))) return;

  /* A 600px-wide copy is sharp up to large headings and is a small file. */
  var url = new URL(src.replace(/([?&]width=)\d+/, '$1600'), location.href).href;
  document.documentElement.style.setProperty('--dv-wm-url', 'url("' + url + '")');

  /* The name, not when it is part of an address (@direvulf, direvulf.com,
     #direvulf, /direvulf) or of a longer word. The leading character is
     captured rather than looked behind, for older Safari. */
  var FIND = /(^|[^@#\w.\/-])(dire\s?vulf)(?![\w@-]|\.[a-z])/gi;
  var HAS = /dire\s?vulf/i;
  var SKIP = [
    'script', 'style', 'noscript', 'template', 'textarea', 'input', 'select',
    'option', 'title', 'code', 'pre', 'svg', '[contenteditable="true"]',
    '.dv-wm', '.visually-hidden', '.sr-only',
    '.dv-brand', '.mobile-nav__brand', '.dv-foot__wordmark',
    '.shopify-policy__container',
    '[class*="cyo"]', '[class*="dv-lab"]',
    '[data-dv-no-wordmark]'
  ].join(',');

  function skipped(node) {
    var el = node.nodeType === 1 ? node : node.parentElement;
    return !el || !!el.closest(SKIP);
  }

  function swap(text) {
    var value = text.nodeValue;
    var frag = null;
    var last = 0;
    var m;
    FIND.lastIndex = 0;
    while ((m = FIND.exec(value))) {
      var start = m.index + m[1].length;
      frag = frag || document.createDocumentFragment();
      if (start > last) frag.appendChild(document.createTextNode(value.slice(last, start)));
      var logo = document.createElement('span');
      logo.className = 'dv-wm';
      var words = document.createElement('span');
      words.className = 'dv-wm__t';
      words.textContent = m[2];
      logo.appendChild(words);
      frag.appendChild(logo);
      last = start + m[2].length;
      FIND.lastIndex = last;
    }
    if (!frag) return;
    if (last < value.length) frag.appendChild(document.createTextNode(value.slice(last)));
    text.parentNode.replaceChild(frag, text);
  }

  function scan(root) {
    if (root.nodeType === 3) {
      if (HAS.test(root.nodeValue) && !skipped(root)) swap(root);
      return;
    }
    if (root.nodeType !== 1 || !HAS.test(root.textContent || '') || skipped(root)) return;
    var walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, {
      acceptNode: function (n) {
        return HAS.test(n.nodeValue) && !skipped(n) ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_SKIP;
      }
    });
    var found = [];
    while (walker.nextNode()) found.push(walker.currentNode);
    found.forEach(swap);
  }

  scan(document.body);

  /* Sections re-rendered by the theme editor, the bag drawer, search
     suggestions and anything else added later. */
  if (window.MutationObserver) {
    new MutationObserver(function (records) {
      records.forEach(function (r) {
        for (var i = 0; i < r.addedNodes.length; i++) scan(r.addedNodes[i]);
      });
    }).observe(document.body, { childList: true, subtree: true });
  }
})();
